'use client';
import React from 'react';
import NavBar from '@/components/NavBar';
import HeroSection from '@/components/HeroSection';
import StatsSection from '@/components/StatsSection';
import AboutSection from '@/components/AboutSection';
import ServicesSection from '@/components/ServicesSection';
import CoursesSection from '@/components/CoursesSection';
import ProcessSection from '@/components/ProcessSection';
import TestimonialsSection from '@/components/TestimonialsSection';
import GoogleReviewsSection from '@/components/GoogleReviewsSection';
import SuccessStoriesSection from '@/components/SuccessStoriesSection';
import FAQSection from '@/components/FAQSection';
import FreeResourcesSection from '@/components/FreeResourcesSection';
import ContactSection from '@/components/ContactSection';
import FinalCTASection from '@/components/FinalCTASection';
import Footer from '@/components/Footer';

export default function HomePage() {
  return (
    <main
      className="min-h-screen"
      style={{
        background: '#0d0818',
        color: '#e8dff5',
      }}
    >
      <NavBar />
      {/* 1. Hero Banner */}
      <HeroSection />
      {/* 2. Why Choose Shreevidha Healing Hub */}
      <StatsSection />
      {/* 3. About Shruti Saxena */}
      <AboutSection />
      {/* 4. Healing Services (1:1 Sessions) */}
      <ServicesSection />
      {/* 5. Signature Courses & Workshops */}
      <CoursesSection />
      {/* 6. Healing Process */}
      <ProcessSection />
      {/* 7. Client Transformations (Testimonials) */}
      <TestimonialsSection />
      {/* 8. Google Reviews */}
      <GoogleReviewsSection />
      {/* 9. Success Stories */}
      <SuccessStoriesSection />
      {/* 10. FAQ */}
      <FAQSection />
      {/* 11. Free Resources */}
      <FreeResourcesSection />
      {/* 12. Contact Section */}
      <ContactSection />
      {/* 13. Final Call To Action */}
      <FinalCTASection />
      {/* 14. Footer */}
      <Footer />
    </main>
  );
}
